import $http from '../../../axios-instance';
import Swal from 'sweetalert2'

export async function listarFabricantes({ state, commit }) {

    if (!state.fabricantes.length) {
        let params = {
            params: {
                paginate: false,
                omitir_ocultos: true
            }
        }

        await $http.get('/fabricantes', params).then((response) => {
            commit('setFabricantes', response.data.fabricantes)
        }).catch((error) => {
            this.$swal({
                position: 'center',
                icon: 'error',
                title: 'Error al cargar fabricantes: ' + error,
                showConfirmButton: false,
                timer: 1500
            })
        })
    }
}

export async function listarIdiomas({ commit, state }) {

    if (!state.idiomas.length) {
        await $http.get('controles/10')
            .then((response) => {
                commit('setIdiomas', response.data)
            })
    }
}

export async function listarTipos({ commit, state }) {

    if (!state.tipos.length) {
        await $http.get('controles/14')
            .then((response) => {
                commit('setTipos', response.data)
            })
    }
}

/**
 * Método para obtener todos los tipos de productos registrados.
 *
 * @param {*} param0
 * @author Santiago Echeverri
 */
export async function cargarTipoProducto({ commit, state }) {
    await $http.get('/controles/19')
        .then((response) => {

            commit('setTipoProductos', response.data)
        })
        .catch((error) => {
            commit('mensajeError', error.message)
        })
}

export async function listarEstadoFds({ commit, state }) {

    if (!state.estados_fds.length) {
        await $http.get('controles/16')
            .then((response) => {
                commit('setEstadosFds', response.data)
            })
    }
}

export async function listarEmpresas({ commit, state }) {
    if (!state.empresas.length) {
        await $http.get('/empresas/lista')
            .then((response) => {
                commit('setEmpresas', response.data.data)
            })
    }
}

export async function listarUbicaciones({ commit }, id_empresa) {
    await $http.get(`company/location/tree/${id_empresa}`)
        .then((response) => {
            commit('setUbicaciones', response.data.data)
        })
}

export async function guardaProducto({ state }) {

    return new Promise(async (resolve, reject) => {
        const moment = require('moment');

        let formData = state.producto;
        formData.doc_etiqueta = (state.sga.categoriasNpeligrosas.length || state.sga.categoriasambiental.length || state.sga.categoriasfisicas.length || state.sga.categoriassalud.length) ? 160 : 161;

        formData.doc_sga = state.adjunto.tipo === 154 && (state.adjunto.idioma === 137 || state.adjunto.idioma === 138) ? 160 : 161;
        if (formData.doc_etiqueta === 160) {
            formData.fecha_etiqueta = moment().format('YYYY-MM-DD');
        }

        await $http.post('adm_productos/crear', formData)
            .then((response) => {
                resolve(response.data.Idproducto)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export async function guardaAdjunto({ commit, state }, id_producto) {

    let cumple_decreto = state.adjunto.estado_fds === 162 ? 'SI' : 'NO'

    commit('setCumpleDecretoAdjunto', cumple_decreto)

    let form_data = new FormData();

    for (let indice in state.adjunto) {
        form_data.append(indice, state.adjunto[indice]);
    }

    return new Promise(async (resolve, reject) => {

        await $http.post(`adm_productos/adjuntos/crear/${id_producto}`, form_data)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


/**
 * Método para obtener la información de sga del sistema.
 *
 * @param {*} param0
 */
export async function getJsonSga({ commit, state }) {
    await $http.post('adm_productos/sga', state.ingreso)
        .then((response) => {
            commit('cargarJsonSga', response.data.data)
        })
        .catch((error) => {

        })

}

/**
 * Método para guardar la información de la clasificación SGA del producto químico.
 *
 * @param {*} param0
 */
export async function guardaSga({ state }, id_producto) {
    return new Promise(async (resolve, reject) => {
        await $http.post(`adm_productos/sga/crear/${id_producto}`, state.sga)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export async function guardaEppIconos({ state }, id_producto) {

    return new Promise(async (resolve, reject) => {

        let parametros = {
            iconos: state.epps
        }

        await $http.post(`adm_productos/eppicos/crear/${id_producto}`, parametros)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export async function guardaAsignacion({ state }, id_producto) {

    let asignaciones = state.empresas.filter(e => e.asignado).map((empresa) => {
        return {
            id: empresa.id,
            activo: true
        }
    })

    return new Promise(async (resolve, reject) => {
        let parametros = {
            asignaciones: asignaciones
        }

        await $http.post(`adm_productos/asignacion_masiva/crear/${id_producto}`, parametros)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export async function guardaUbicacion({ state, commit }, data) {
    let parametros = {
        ubicaciones: data.ubicaciones,
        id_empresa: data.id_empresa
    }

    commit('dashboard/load', true, {root: true});
    try {
        const response = await $http.post(`adm_productos/ubicaciones-masiva/${data.id_producto}`, parametros)

        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500
        })
    } catch (error) {

        await Swal.fire({
            position: 'center',
            icon: 'warning',
            title: error.response.message,
            showConfirmButton: false,
            timer: 1500
        })
    }
    commit('dashboard/load', false, {root: true});
}


/**
 * Guardar producto quimico rol empresa contratista.
 *
 * @param {*} formData
 */
export async function createProductByContractorCompany({ state },formData) {
    return new Promise(async (resolve, reject) => {
        await $http.post('products/create-by-contractor-company', formData)
            .then((response) => {
                resolve(response.data.data.Idproducto)
            })
            .catch((error) => {
                if (this.$vue.$alertErrorsCallback(error)) return;
                this.$vue.$alertError(error.message);
                reject(error)
            })
    })
}




